import { forEach } from 'lodash';
import { Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { combineLatest, filter, map, Subscription } from 'rxjs';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ChangeDetectorRef, Component, Inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { SharedService } from '../../services';

declare const FB: any;

@Component({
  template: '',
})
export class BaseLayoutComponent implements OnDestroy {
  private routerSubscription: Subscription;

  isLoading = true;
  constructor(
    protected router: Router,
    protected metaTagService: Meta,
    protected renderer: Renderer2,
    protected sharedService: SharedService,
    protected cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected platformId: Object,
    @Inject(DOCUMENT) protected document: Document,
  ) {
    this.routerSubscription = combineLatest([this.router.events, this.sharedService.links$, this.sharedService.tags$])
      .pipe(
        filter(([event]) => event instanceof NavigationStart || event instanceof NavigationEnd),
        map(([event, links, tags]) => {
          if (isPlatformBrowser(this.platformId)) {
            if (event instanceof NavigationStart) {
              this.scrollToTop();

              forEach(links, (link) => this.renderer.removeChild(this.document.head, link));

              forEach(tags, (tag) => this.metaTagService.removeTagElement(tag));
            }
          }
          return event;
        }),
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.isLoading = false;
        this.cd.markForCheck();
      });
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
